module.exports = __webpack_public_path__ + "img/76-Gris DB 703 Alux.jpg";